/**
 * Labstep
 *
 * @module components/Profile/Picture
 * @desc Profile Picture. Allows for upload new on Click.
 */

import { useHasAccess } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { FileActionUploadContainer as FileActionUpload } from 'labstep-web/components/File/Action/Upload';
import { ProfilePictureImagePopup as ProfileImage } from 'labstep-web/components/Profile/Picture/Image';
import { PopupContainer as Popup } from 'labstep-web/core/Popup';
import type React from 'react';
import type {
  IProfilePictureProps,
  IUpdatableProfilePhotoProps,
} from './types';

export const UpdatableProfilePhoto: React.FC<
  IUpdatableProfilePhotoProps
> = ({ ...rest }) => (
  <FileActionUpload
    entityId={rest.entity.profile.id}
    entityType="profile"
    type="image"
  >
    <Popup
      trigger={
        <div style={{ cursor: 'pointer' }}>
          <ProfileImage {...rest} linkable={false} />
        </div>
      }
      content="Upload image"
      size="mini"
    />
  </FileActionUpload>
);

export const ProfilePicture: React.FC<IProfilePictureProps> = ({
  uploadable,
  ...rest
}) => {
  const canEdit = useHasAccess(
    rest.entity.entityName,
    rest.entity.id,
    Action.edit,
  );
  if (uploadable && canEdit) {
    return <UpdatableProfilePhoto {...rest} />;
  }

  return <ProfileImage {...rest} />;
};

ProfilePicture.defaultProps = {
  uploadable: false,
};
